import { useState } from 'react';
import TentLightbox, { TentData } from './TentLightbox';

const tents: TentData[] = [
  {
    name: '12 × 20ft Stretch Tent',
    image: '/assets/img/363446df50e5.webp',
    dimensions: '12 × 20ft',
    sqft: '240 sqft',
    capacity: [
      '15–20 PAX: Cinema / Dancing / Cocktail',
    ],
  },
  {
    name: '20 × 20ft Stretch Tent',
    image: '/assets/img/fba1d3007ba5.webp',
    dimensions: '20 × 20ft',
    sqft: '400 sqft',
    capacity: [
      '25–30 PAX: Cinema / Dancing / Cocktail',
    ],
  },
  {
    name: '30 × 40ft Stretch Tent',
    image: '/assets/img/4f042db7dcf9.webp',
    dimensions: '30 × 40ft',
    sqft: '1,200 sqft',
    capacity: [
      '65–70 PAX: Cinema / Cocktail',
      '50 PAX: Seated Dining',
    ],
  },
  {
    name: '40 × 60ft Stretch Tent',
    image: '/assets/img/fa691ca2b57f.webp',
    dimensions: '40 × 60ft',
    sqft: '2,400 sqft',
    capacity: [
      '150 PAX: Cinema / Cocktail',
      '100 PAX: Seated Dining',
    ],
  },
  {
    name: '65 × 50ft Stretch Tent',
    image: '/assets/img/5314426f1c54.webp',
    dimensions: '65 × 50ft',
    sqft: '3,250 sqft',
    capacity: [
      '200 PAX: Cinema / Cocktail',
      '150 PAX: Seated Dining',
    ],
  },
  {
    name: '65 × 100ft Stretch Tent',
    image: '/assets/img/139787e0e655.webp',
    dimensions: '65 × 100ft',
    sqft: '6,500 sqft',
    capacity: [
      '500 PAX: Cinema / Cocktail',
      '350 PAX: Seated Dining',
    ],
  },
  {
    name: '3000 sqft Hexagon Tent',
    image: '/assets/img/0f0acbff3e02.webp',
    dimensions: 'Hexagon',
    sqft: '3,000 sqft',
    capacity: [
      '150–180 PAX: Cinema / Cocktail',
      '120 PAX: Seated Dining',
    ],
  },
  {
    name: '5300 sqft Hexagon Tent',
    image: '/assets/img/e91e4656a9a3.webp',
    dimensions: 'Hexagon',
    sqft: '5,300 sqft',
    capacity: [
      '300 PAX: Cinema / Cocktail',
      '250 PAX: Seated Dining',
    ],
  },
];

export default function TentGrid() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const openLightbox = (index: number) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);
  const prevTent = () =>
    setLightboxIndex((prev) =>
      prev !== null ? (prev - 1 + tents.length) % tents.length : 0
    );
  const nextTent = () =>
    setLightboxIndex((prev) =>
      prev !== null ? (prev + 1) % tents.length : 0
    );

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Choose Your Size</h2>
          <p className="text-gray-500 text-base">
            Click any tent to explore it in detail
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {tents.map((tent, index) => (
            <div
              key={index}
              onClick={() => openLightbox(index)}
              className="group bg-white border border-gray-100 rounded-2xl overflow-hidden cursor-pointer hover:-translate-y-1 hover:border-teal-200 transition-all duration-300"
            >
              {/* Image */}
              <div className="relative h-52 bg-gray-50 overflow-hidden">
                <img
                  src={tent.image}
                  alt={tent.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute top-3 right-3 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-zoom-in-line text-teal-500 text-sm"></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-start justify-between mb-2">
                  <h3 className="font-bold text-gray-900 text-base leading-snug">
                    {tent.name}
                  </h3>
                </div>
                <p className="text-teal-500 font-semibold text-sm mb-3">
                  {tent.dimensions} &nbsp;·&nbsp; {tent.sqft}
                </p>
                <div className="space-y-1">
                  {tent.capacity.map((cap, i) => (
                    <p key={i} className="text-xs text-gray-500 flex items-start gap-1.5">
                      <i className="ri-user-3-line text-gray-400 mt-0.5 flex-shrink-0"></i>
                      {cap}
                    </p>
                  ))}
                </div>
                <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                  <span className="text-xs text-teal-500 font-semibold group-hover:underline">
                    View Details
                  </span>
                  <i className="ri-arrow-right-line text-teal-400 text-sm group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightboxIndex !== null && (
        <TentLightbox
          tents={tents}
          currentIndex={lightboxIndex}
          onClose={closeLightbox}
          onPrev={prevTent}
          onNext={nextTent}
        />
      )}
    </section>
  );
}
